import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { LeaderCriteriaRuleResponse } from "~pages/LeaderCriteria/types/leaderCriteriaRule.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

type Props = {
  customParams: Record<string, string>;
};

export const useFetchLeaderCriteriaRules = ({ customParams }: Props) => {
  const request = useApi();
  const { organizationId, sport, leaderCriteriaId } = useParams();

  const params = new URLSearchParams(removeEmptyFields(customParams) as Record<string, string>);

  return useQuery({
    queryKey: ["leaderCriteriaRules", sport, organizationId, leaderCriteriaId, customParams],
    queryFn: () =>
      request<LeaderCriteriaRuleResponse>(
        `${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}/qualifiers?${params.toString()}`,
      ).then((response) => transformListResponse(response)),
    enabled: !!leaderCriteriaId,
  });
};
